import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { initializeRWA } from "../services/RWA";
import { getConfigVars } from "reducer";

export const useAnalytics = () => {
  const location = useLocation();
  const config = useSelector(getConfigVars) as {
    RWA_ENABLED?: string;
    RWA_EVENT_STREAM_URL?: string;
  };

  // Initialize RWA once on mount
  useEffect(() => {
    initializeRWA(config);
  }, [config]);

  // Track page views on route changes
  useEffect(() => {
    if (!window.RWA) return;

    try {
      window.RWA.createPageView({
        path: location.pathname,
        title: document.title,
        qs: location.search,
        hash: location.hash
      });
    } catch (error) {
      console.error("Failed to create RWA page view:", error);
    }
  }, [location.pathname, location.search, location.hash]);
};
